export default "/corgi/pageapps/purchase/_next/static/media/red-crossmark.4bae74bd.svg";